import { render, staticRenderFns } from "./create-business.vue?vue&type=template&id=0906bf0a&"
import script from "./create-business.vue?vue&type=script&lang=js&"
export * from "./create-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports